import * as TAGSORT from "../plugins/tagsort"

const [ w, d, l ] = [ window, document, location ]
const content = 'topics'

// 全記事取得
let articles = $.getArticles({ content })
let categories = $.getCategories({ content })

const init = async () => {
  let tags = TAGSORT.getTags( await articles )
  
  // 非表示タグの設定
  const minimumTagAmount = 13 /* タグの最低表示数 */
  const hideUselessTags = 4 /* 最低使用回数 */
  
  // taglistの作成
  const $container = $('<div class="block-taglist align-center"/>')
  const $tagContainer = $('<div calss="block-taglist__tags" />')
  const $title = $(`<h3 class="block-taglist__title"><span><em>#</em>人気のタグ</span></h3>`)
  const tagClass = 'class="button-tag"'

  $container.append( $title )

  // タグリンク追加
  $.each(tags, ( i, tag ) => {
    const is_active = ( w.query_string('tag') == tag.slug )
    const $taglink = $(`<a href="/${content}/?mode=list&tag=${tag.slug}" ${tagClass}>${tag.name}</a>`)

    $taglink.addClass( is_active ? 'is-current':'' )
    
    // 最小表示数を超える場合 かつ 使用頻度が低いものを非表示
    if( i >= minimumTagAmount && hideUselessTags > tag.count ){
      $taglink.addClass( 'is-short' ).hide()
    }

    $tagContainer.append( $taglink )
  })
  $tagContainer.appendTo( $container )

  // 低使用頻度のタグ表示トグル
  if( $('.is-short', $container ).length > 0 ){

    const icon = {
      up : '<i class="fa fa-angle-double-up" aria-hidden="true"></i>',
      down : '<i class="fa fa-angle-double-down" aria-hidden="true"></i>'
    }
    const $tagDispToggleBtn = $(`<button class="button button-text button-xsmall">全てを表示 ${icon.down}</button>`)

    $tagDispToggleBtn.on('click', function() {
      const $btn = $(this)
      const $container = $btn.parents('.block-taglist')

      $('.is-short', $container).fadeToggle(200)
      $btn.toggleClass('is-active')

      const btnhtml = $btn.hasClass('is-active') ? `一部のみ表示 ${icon.up}`: `全てを表示 ${icon.down}`
      $btn.html( btnhtml )
    })

    $tagDispToggleBtn.appendTo( $title ).wrapAll('<div class="block-taglist__btnWrap button-wrap" />')
  }

  $(() => {
    w.load['block-topics-tags'].done(() => $('[data-plugin="dispTags"]').replaceWith( $container ) )
  })

  // サイドカラムのサムネイル画像差し替え
  $('.artloop .thum_img img').each( (i, obj) => {
    obj.src = obj.src.replace(/\/thumb-/,'/')
  })
}

const list_init = async () => {

  // pickup 
  articles = await articles
  categories = await categories
  let pickup_article = articles.filter( a => (a.category == 1) ).shift() // イベントカテゴリのみ
  let tags = keywords => {
    let html = ""
    if(!keywords || keywords.length == 0) return ''
    keywords.forEach( key => html += `<span class="tag">${key}</span>` )
    return `<div class="${content}-pickup-item__tags">${html}</div>`
  }
  pickup_article.category = categories.filter( c => c.id == pickup_article.category )[0]
  let $pickupContainer = $(`<div class="topics-pickup"><h3 class="topics-pickup__title">PICKUP EVENT</h3></div>`)
  let $pickupItem = $(`
    <a class="${content}-pickup-item" href="${pickup_article.href}">
      <figure class="${content}-pickup-item__img">
        <div class="${content}-pickup-item__img-inner" style="background-image:url( ${pickup_article.thumb} )">
          <img src="${pickup_article.thumb}" width="200">
        </div>
        <span class="${content}-pickup-item__cat" class="is-cat${pickup_article.category.id}">${pickup_article.category.name}</span>
      </figure>
      <div class="${content}-pickup-item__body">
        <h5 class="${content}-pickup-item__title">${ pickup_article.title }</h5>
        <p class="${content}-pickup-item__desc">${ pickup_article.desc }</p>
        ${tags(pickup_article.keywords)}
        <span class="date">${ w.datetostr( pickup_article.date * 1000, "YYYY.MM.DD" )}</span>
      </div>
    </a>
  `)
  $pickupItem.appendTo( $pickupContainer )
  $pickupContainer.prependTo('#container')
  d.addEventListener('tagsort.pageChange',() => {
    if( !w.query_string('page') || w.query_string('page') == 1 ) $pickupContainer.show()
    else $pickupContainer.hide()
  })

}

const detail_init = async () => {
  articles = await articles
  categories = await categories
  
  let the_id = d.body.classList.value.replace(/^.+is--article-([\d]+)(.+)?$/,'$1')

  let the_article = articles.filter( a => (a.id == the_id) ).shift()
  the_article.category = categories.filter( c => c.id == the_article.category )[0]

  // 詳細ヘッダー
  let tags = keywords => {
    let html = ""
    if(!keywords || keywords.length == 0) return ''
    keywords.forEach( key => html += `<a href="/topics/?mode=list&tag=${ encodeURI( key ) }">${key}</a>` )
    return `<div class="topics-detail__tags">${html}</div>`
  }
  let $head = $(`
    <div class="topics-detail__head">
      ${the_article.category.name ? `<span class="cat">${the_article.category.name}</span>`: '' }
      <h3 class="title">${the_article.title}</h3>
      ${the_article.desc.length ? `<p class="desc">${the_article.desc}</p>`: '' }
      <p class="date">${w.datetostr( the_article.date * 1000, 'YYYY.MM.DD' )}</p>
    </div>
  `)
  $('.element_detail > .title, .detail_title').remove()
  $head.prependTo('.element_detail')
  
  // ページングボタン名
  let opt ={
        prev:'PREV',
        next:'NEXT',
        list:'一覧へ戻る'
      };
  let $pagination = $( '.paginationbox .pageNav>a[href]' )

  $pagination.each(function(){
    let id = this.href.match(/article=([\d]+)/)[1],
        item = articles.filter(function(o,i){
          if(o.id==id) return true;
        }).shift();
    let html = `
      <span>${item.title}</span>
      <figure class="thumb"><img src="${item.thumb}" width="120" /></figure>
    `
    if( this.classList.contains('prev') ) opt.prev = html
    if( this.classList.contains('next') ) opt.next = html
  });
  $.pagingText(opt)

  $('.detailfooter').appendTo('#container')

  // フォームブロック追加
  let formHtml = await $.get('/asset/html/block-topics-form.html')
  let $form = $( await formHtml )
  let formAction = {
    'localhost': 'http://local.hybs.jp/inquiry/',
    'www.ishimaki.websapo.jp': 'https://secure3.websapo.jp/inquiry/',
    'www.ishimaki.com': 'https://secure3.websapo.jp/inquiry/'
  }
  if( the_article.category.id == 1 ){
    $form.appendTo('.element_detail .entry')
    $form.parent().find('form[name="form1"]').attr('action', formAction[l.hostname]||'' )
  }

  // この記事のタグリスト追加
  $('.element_detail .entry').append( $(tags(the_article.keywords) ) )

}


export default function TOPICS () {
  d.addEventListener('DOMContentLoaded', () => {
    init()
    if( d.querySelectorAll('.element_detail').length ) detail_init()
    if( d.querySelectorAll('#main .element_list').length ) list_init()
  })
}